import validate from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/node_modules/nuxt/dist/pages/runtime/validate.js";
import sdk_45list_45global from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/middleware/sdk-list.global.ts";
export const globalMiddleware = [
  validate,
  sdk_45list_45global
]
export const namedMiddleware = {}